
























































import { Component, Vue } from 'vue-property-decorator';
import Btn from '@/components/Btn.vue';

@Component({
  name: 'home-page',
  components: { Btn },
  // beforeRouteEnter: async (to, from, next) => {
  //   next(vm => {
  //   });
  // }
})
export default class HomeComponent extends Vue {

}
